import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {getMoreOffers, getOffers} from '../../actions/offers.action';
import Product from '../../components/Product/Product';
import {syncBasketQuantityWithProducts} from '../../helpers/product.helper';
import {getFilterPillItems} from '../../helpers/data.helper';
import Loading from '../../components/Loading/Loading';
import {NoOffers} from './OffersPage.style';
import InfiniteScroll from 'react-infinite-scroll-component';
import queryString from 'query-string';
import {
  ANALYTICS_SOURCES,
  ROUTES,
  SCROLL_THRESHOLD,
  SEARCH_SORT_OPTIONS,
  SEARCH_SORT_TYPE,
  getInitialPageSize,
} from '../../constants/constants';
import {
  BreadCrumb,
  BreadCrumbLinks,
  ClearFilter,
  Container,
  CurrentPage,
  DoneButton,
  FilterButton,
  FilterButtonWrapper,
  FilterInfo,
  FilterOverlayBackdrop,
  FilterPill,
  FilterPillsWrapper,
  FiltersButtons,
  FiltersScrollArea,
  FiltersWrapper,
  NameWrapper,
  ProductCount,
  ResultsPanel,
  ResultsTitle,
  ResultsWrapper,
  Separator,
  SortButton,
  SortDropdownItem,
  SortDropdownPanel,
  SortWrapper,
  Status,
  ToolBar,
} from '../SearchPage/SearchPage.style';
import Filters from '../../components/Filters/Filters';
import {setCurrentRoute} from '../../actions';
import ToTheTop from '../../components/ToTheTop/ToTheTop';
import {setPrevRoute} from '../../actions/prevRoute.action';
import {setPageHeadTags} from '../../helpers/seo.helper';
import {loadSearchResultsData} from '../../routes/loadDataForRoutes';
import {LeftLine, RightLine} from '../../styles/components/lines';

class OffersPage extends PureComponent {
  sortWrapperRef = React.createRef();
  filtersScrollRef = React.createRef();
  _savedScrollY = 0;

  state = {
    showFilterInMobile: false,
    showSortDropdown: false,
    isCurrentSearch: false,
    params: null,
    pageTitle: 'Our Special Offers',
  };

  async componentDidMount() {
    const {history, prevRoute} = this.props;
    const isNewSearch =
      history.location &&
      history.location.state &&
      history.location.state.newSearch;
    setCurrentRoute(ROUTES.OFFERS);
    if (prevRoute === ROUTES.PRODUCT && !isNewSearch) {
      return;
    }
    this.getOffers();
    document.addEventListener('mousedown', this.handleSortOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleSortOutsideClick);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.location.search !== prevState.search) {
      const {location} = nextProps;
      const params = queryString.parse(location.search);
      const prevParams = queryString.parse(prevState.search);
      return {
        params,
        search: location.search,
        isCurrentSearch: params.q === prevParams.q,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    const {branch, basket, settings, setCurrentRoute} = this.props;
    const {params} = this.state;
    setCurrentRoute(ROUTES.OFFERS);
    // sync the offers to basket fulfillment type and slot date
    if (
      (prevProps.basket &&
        prevProps.basket.fulfillment &&
        basket &&
        basket.fulfillment &&
        prevProps.basket.fulfillmentType !== basket.fulfillmentType) ||
      prevProps.settings !== settings ||
      (prevProps.branch && prevProps.branch !== branch)
    ) {
      this.getOffers();
    }
    if (params.adTitle) {
      setPageHeadTags(loadSearchResultsData(params.adTitle));
      this.setState({pageTitle: params.adTitle});
    }
  }

  async getOffers() {
    const {getOffers, branch} = this.props;
    const {params} = this.state;
    const size = (params && params.size) || getInitialPageSize();
    getOffers(branch, {...params, size});
  }

  loadMore = () => {
    const {getMoreOffers, branch, offers} = this.props;
    const {params} = this.state;
    getMoreOffers(branch, offers.page.number + 1, params);
  };

  updateSearchParams = (updatedParams, resetPageNumber) => {
    const {history, location} = this.props;

    const urlParams = queryString.parse(location.search);
    let params = Object.assign({}, urlParams, updatedParams);
    if (resetPageNumber) {
      params = Object.assign({}, params, {page: 0});
    }
    history.push({
      pathname: '/offers',
      search: `?${queryString.stringify(params)}`,
    });
    this.setState({params}, () => this.getOffers());
  };

  clearFilters = () => {
    const {q, b, size, advanced} = this.state.params;
    let params;
    if (q === '*' && advanced === 'true') {
      params = {q, b, advanced};
    } else {
      params = {q, b, size};
    }
    this.props.history.push({
      pathname: '/offers',
      search: `?${queryString.stringify(params)}`,
    });
    this.setState({params}, () => {
      this.getOffers();
      window.scrollTo(0, 150);
    });
  };

  applyFilters = () => {
    this.closeFilterInMobile();
  };

  lockBodyScroll = () => {
    this._savedScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  };

  unlockBodyScroll = () => {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, this._savedScrollY);
  };

  toggleFilterInMobile = () =>
    this.setState(
      prev => ({showFilterInMobile: !prev.showFilterInMobile}),
      () => {
        if (this.state.showFilterInMobile) {
          this.lockBodyScroll();
          if (this.filtersScrollRef.current) {
            this.filtersScrollRef.current.scrollTop = 0;
          }
        } else {
          this.unlockBodyScroll();
        }
      }
    );

  closeFilterInMobile = () => {
    this.setState({showFilterInMobile: false});
    this.unlockBodyScroll();
  };

  handleSortOutsideClick = e => {
    if (
      this.sortWrapperRef.current &&
      !this.sortWrapperRef.current.contains(e.target)
    ) {
      this.setState({showSortDropdown: false});
    }
  };

  toggleSortDropdown = () =>
    this.setState(prev => ({showSortDropdown: !prev.showSortDropdown}));

  selectSort = value => {
    this.updateSearchParams({sortType: value}, true);
    this.setState({showSortDropdown: false});
  };

  render() {
    const {
      offers,
      loading,
      branch,
      updateBasket,
      updateItem,
      removeItem,
      basketHashMap,
      basket,
      deviceInfo,
      page,
      aggression,
      onProductClick,
      keywordSearch,
      setPrevRoute,
    } = this.props;
    const navToProduct = itemId => {
      setPrevRoute(ROUTES.OFFERS);
      onProductClick(itemId);
    };
    const {
      showFilterInMobile,
      showSortDropdown,
      params,
      isCurrentSearch,
    } = this.state;
    const appliedFilters = {
      sizeOrCut: !!params.sizeOrCut,
      origin: !!params.origin,
      brand: !!params.brand,
      productFeatures: !!params.productFeatures,
      categoryList: !!params.category,
    };
    const offersList =
      offers && syncBasketQuantityWithProducts(basketHashMap, offers.products);
    const renderOffer =
      offersList && offersList.length > 0 ? (
        offersList.map((product, index) => (
          <Product
            product={product}
            branch={branch}
            key={product.itemId + index}
            searchId={product._searchId}
            searchPosition={index}
            onProductClick={navToProduct}
            loading={loading}
            basketHashMap={basketHashMap}
            updateBasket={updateBasket}
            updateItem={updateItem}
            removeItem={removeItem}
            fulfillmentType={basket && basket.fulfillmentType}
            deviceInfo={deviceInfo}
            source={ANALYTICS_SOURCES.OFFERS}
            keywordSearch={keywordSearch}
          />
        ))
      ) : offersList && offersList.length === 0 ? (
        <NoOffers>Sorry, no offers available</NoOffers>
      ) : (
        <Loading isLight={false} />
      );
    const hasMore =
      offers && offers.page && offers.page.number < offers.page.totalPages - 1;
    const renderAllOffers = offersList && (
      <InfiniteScroll
        next={this.loadMore}
        hasMore={hasMore}
        dataLength={offersList.length}
        scrollThreshold={SCROLL_THRESHOLD}
        loader={<Loading isLight={false} />}
      >
        {renderOffer}
      </InfiniteScroll>
    );

    const renderFilterButton = offersList && offersList.length > 0 && (
      <FilterButtonWrapper>
        <FilterButton onClick={this.toggleFilterInMobile}>
          {showFilterInMobile ? 'Hide Filters' : 'Show Filters'}
          <Status $selected={showFilterInMobile} />
        </FilterButton>
      </FilterButtonWrapper>
    );

    const renderFilters = aggression && (
      <Filters
        params={params}
        updateSearchParams={this.updateSearchParams}
        filters={aggression}
        appliedFilters={appliedFilters}
        showInMobile={showFilterInMobile}
        isCategorySearch={false}
        isCurrentSearch={isCurrentSearch}
        closedByDefault={true}
      />
    );

    const renderFilterTitle = page && !!page.totalElements && (
      <FilterInfo>
        <span>{`Filter ${page.totalElements} products by:`}</span>
        <ClearFilter onClick={this.clearFilters}>clear filters</ClearFilter>
      </FilterInfo>
    );

    const renderFiltersWrapper = offersList && offersList.length > 0 && (
      <FiltersWrapper $showInMobile={showFilterInMobile}>
        <FiltersScrollArea ref={this.filtersScrollRef}>
          {renderFilterTitle}
          {renderFilters}
        </FiltersScrollArea>
        <FiltersButtons>
          <DoneButton onClick={this.applyFilters}>Apply Filters</DoneButton>
        </FiltersButtons>
      </FiltersWrapper>
    );

    const renderGoTop = page && page.number > 0 && <ToTheTop />;

    const filterPillItems = getFilterPillItems(aggression);
    const renderFilterPills = filterPillItems.length > 0 && (
      <FilterPillsWrapper>
        <div>
          {filterPillItems.map(({id, name, unqueryParams}) => (
            <FilterPill
              key={id}
              onClick={() => this.updateSearchParams(unqueryParams)}
            >
              {name}
            </FilterPill>
          ))}
        </div>
      </FilterPillsWrapper>
    );

    const renderContent = offersList && (
      <Container>
        <FilterOverlayBackdrop
          $show={showFilterInMobile}
          onClick={this.closeFilterInMobile}
        />
        {renderFiltersWrapper}
        <ResultsPanel>
          {renderFilterPills}
          <ResultsWrapper $gridView={true} $maxColumns={4}>
            {renderAllOffers}
          </ResultsWrapper>
        </ResultsPanel>
        {renderGoTop}
      </Container>
    );

    return (
      <Fragment>
        <BreadCrumb>
          <span>
            <BreadCrumbLinks to="/">Home</BreadCrumbLinks>
            <Separator> › </Separator>
            <CurrentPage $noPadding>{this.state.pageTitle}</CurrentPage>
          </span>
          {page && page.totalElements > 0 && (
            <ProductCount>{page.totalElements} Products found</ProductCount>
          )}
        </BreadCrumb>
        <ToolBar>
          <SortWrapper ref={this.sortWrapperRef}>
            <SortButton onClick={this.toggleSortDropdown}>
              {`Sort: ${
                (
                  SEARCH_SORT_OPTIONS.find(
                    o =>
                      o.value ===
                      ((params && params.sortType) ||
                        SEARCH_SORT_TYPE.RELEVANCE)
                  ) || SEARCH_SORT_OPTIONS[0]
                ).label
              }`}
            </SortButton>
            {showSortDropdown && (
              <SortDropdownPanel>
                {SEARCH_SORT_OPTIONS.map(opt => (
                  <SortDropdownItem
                    key={opt.value}
                    $active={
                      ((params && params.sortType) ||
                        SEARCH_SORT_TYPE.RELEVANCE) === opt.value
                    }
                    onClick={() => this.selectSort(opt.value)}
                  >
                    {opt.label}
                  </SortDropdownItem>
                ))}
              </SortDropdownPanel>
            )}
          </SortWrapper>
          {renderFilterButton}
        </ToolBar>
        <ResultsTitle>
          <LeftLine />
          <NameWrapper>{this.state.pageTitle}</NameWrapper>
          <RightLine />
        </ResultsTitle>
        {renderContent}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    branch: state.branch,
    basket: state.basket,
    loading: state.loading,
    offers: state.offers,
    basketHashMap: state.basketHashMap,
    aggression: state.aggression,
    page: state.page,
    settings: state.settings,
    prevRoute: state.prevRoute,
  };
};

const mapDispatchToProps = dispatch => ({
  getOffers: bindActionCreators(getOffers, dispatch),
  getMoreOffers: bindActionCreators(getMoreOffers, dispatch),
  setCurrentRoute: bindActionCreators(setCurrentRoute, dispatch),
  setPrevRoute: bindActionCreators(setPrevRoute, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(OffersPage);
